// extracted by mini-css-extract-plugin
module.exports = {"InvestmentTable":"styles_InvestmentTable__17WRo","Green":"styles_Green__1idyh","Red":"styles_Red__1df5t"};